import React, { useEffect } from 'react'
import BlogSlider from './BlogSlider';
import { Tabs, Button } from 'antd';

const { TabPane } = Tabs;

const viewAll = <Button type="primary" >View All</Button>;

function BlogSection() {
    return (
        <div className="mt-16">

            <div className="p-4 m-4 rounded-lg shadow bg-white">
                <div className="p-2">
                    <h2 className="text-2xl font-bold text-gray-700">News & Update</h2>
                    
                    <Tabs defaultActiveKey="1" tabBarExtraContent={viewAll}>
                        <TabPane tab="Tractor News" key="1">
                            <BlogSlider />
                        </TabPane>

                        <TabPane tab="Agriculture news" key="2">
                            <BlogSlider />
                        </TabPane>
                    </Tabs>
                    
                </div>
            </div>

        </div>
    );
}

export default BlogSection;
